import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [Icons, setIcons] = useState(null);

  useEffect(() => {
    // Defer icon loading to improve LCP
    import('lucide-react').then((module) => {
      setIcons({ Menu: module.Menu, X: module.X });
    });
  }, []);

  return (
    <header className="bg-dark-blue text-white sticky top-0 z-50 shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <Link to="/" data-discover="true" className="flex items-center space-x-2" itemScope itemType="https://schema.org/Organization">
            <img src="/images/favicon.webp" alt="BritSpin Hub" className="h-10 w-10" itemprop="logo" loading="eager" fetchPriority="high" width="40" height="40" />
            <div className="text-2xl font-bold bg-gradient-to-r from-white to-red-400 bg-clip-text text-transparent" itemprop="name">
              BritSpin Hub
            </div>
          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" data-discover="true" className="hover:text-accent-red transition-colors">
              Home
            </Link>
            <Link to="/guides" data-discover="true" className="hover:text-accent-red transition-colors">
              Guides
            </Link>
            <Link to="/news" data-discover="true" className="hover:text-accent-red transition-colors">
              News
            </Link>
            <Link to="/reviews" data-discover="true" className="hover:text-accent-red transition-colors">
              Reviews
            </Link>
          </nav>

          

          <button
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {Icons ? (
              isMenuOpen ? <Icons.X size={24} /> : <Icons.Menu size={24} />
            ) : (
              <span className="text-white text-xl">{isMenuOpen ? '✕' : '☰'}</span>
            )}
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-dark-blue-light">
            <nav className="flex flex-col space-y-4">
              <Link to="/" data-discover="true" className="hover:text-accent-red transition-colors" onClick={() => setIsMenuOpen(false)}>
                Home
              </Link>
              <Link to="/guides" data-discover="true" className="hover:text-accent-red transition-colors" onClick={() => setIsMenuOpen(false)}>
                Guides
              </Link>
              <Link to="/news" data-discover="true" className="hover:text-accent-red transition-colors" onClick={() => setIsMenuOpen(false)}>
                News
              </Link>
              <Link to="/reviews" data-discover="true" className="hover:text-accent-red transition-colors" onClick={() => setIsMenuOpen(false)}>
                Reviews
              </Link>
              
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;

